import React, { FC, useEffect, useState } from 'react';
import { Button } from '@material-ui/core';
import { useStyles } from './styles';
import { ClientPortalIcon } from '../CustomIcons';
import { useAppData } from '../../providers';
import { defaultLocale } from '../../utils';

export const QuickLinks: FC = () => {
  const classes = useStyles();
  const [translation, setTranslation] = useState<any>([]);
  const { clientPortalRedirectUrl, translations, locale } = useAppData();

  useEffect(() => {
    setTranslation(JSON.parse(translations));
  }, [translations]);

  return (
    <Button variant="outlined" className={classes.linkButtons} href={clientPortalRedirectUrl ? (locale === defaultLocale ? clientPortalRedirectUrl : `${clientPortalRedirectUrl}/${locale}`) : ''} target="_blank" startIcon={<ClientPortalIcon />}>
      {translation.backToClientPortal}
    </Button>
  );
};
